/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base breakpoints for the Material Dashboard 2 React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire Material Dashboard 2 React using thie file.
 */

/**
 * Renix: `navOverlay` and `navFull` are the *only* two thresholds the sidenav is allowed to switch
 * on. They exist as named keys (instead of reusing `xl`/`laptop`) because the drawer's behavior is
 * spread over five files — SidenavRoot, DashboardLayout, DashboardNavbar/styles, SidenavRevealStrip
 * and the derive effect in App.js — and every one of them has to agree. Retuning `xl` instead would
 * drag along every unrelated `up("xl")` in the app.
 *
 * - `navOverlay` (1024): at or above it the drawer sits *beside* the content (rail or full) and
 *   DashboardLayout reserves margin for it; below it the drawer is an off-canvas overlay opened
 *   from the navbar hamburger. 1024 is the landscape-tablet line — iPad 10.9 (1180) and Pro 11"
 *   (1194) can host the 80px rail with ~1075px of content left.
 * - `navFull` (1440): at or above it `auto` mode shows the full 224px menu. Derived from content
 *   budget: the widest tables want ~1150px, full nav costs 248px, page padding 24px. 1440 also
 *   covers the common real configs a 1600 threshold wrongly demoted to the rail — 1920@125%
 *   scaling (1536 CSS px), 14" MacBook (1512), 13" Air (1470).
 */
const breakpoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    navOverlay: 1024,
    xl: 1200,
    xxl: 1400,
    navFull: 1440,
    laptop: 1600,
  },
};

export default breakpoints;
